import { Link, useLocation } from "react-router";
import { sectionNavigationItems } from "@util/constant";
import { cn } from "@util/helpers";

import { ThriveCategory } from "./types";

/**
 * Component to render thrive navigation items on thrive pages
 * https://www.figma.com/design/UWKZEzXYf0Gf5e6sfqsKVC/THRIVE-WORKING-FILE?node-id=8869-84185&m=dev
 */
const ThriveNavigation = (): React.ReactElement => {
  const { pathname } = useLocation();

  const buttonClassName =
    "px-5 lg:px-4 py-3 lg:w-[100px] text-center text-xs text-grey-850 font-inter font-semibold rounded-[30px] border border-blue-155 hover:bg-blue-155 hover:border-blue-155";
  const thriveNavigationItem = sectionNavigationItems["thrive"];
  const thriveChildrens = thriveNavigationItem.children;

  return (
    <div
      className="mb-6 flex flex-row flex-wrap items-center justify-center gap-[10px] lg:mb-8 lg:items-start lg:justify-start"
      data-testid="thrive-navigation"
    >
      <Link
        to={thriveNavigationItem.link}
        key={thriveNavigationItem.key}
        className={cn(buttonClassName, {
          "border-green-400 bg-green-400 !text-white":
            pathname === thriveNavigationItem.link,
        })}
        reloadDocument
      >
        All
      </Link>

      {thriveChildrens?.map((thriveChildren) => {
        const thriveChildItem = sectionNavigationItems[thriveChildren];

        return (
          <Link
            to={thriveChildItem.link}
            key={thriveChildItem.key}
            className={cn(buttonClassName, {
              "border-green-150 hover:border-green-150 hover:bg-green-150":
                thriveChildItem.key === ThriveCategory.ABOUT,
              "border-yellow-100 hover:border-yellow-100 hover:bg-yellow-100":
                thriveChildItem.key === ThriveCategory.EVENTS,
              "border-green-400 bg-green-400 !text-white":
                pathname === thriveChildItem.link,
            })}
            reloadDocument
          >
            {thriveChildItem.label}
          </Link>
        );
      })}
    </div>
  );
};

export default ThriveNavigation;
